export default "__VITE_ASSET__45efebf0__"